<div
  class="relative min-h-240"
  >
  <ng-content></ng-content>
  @if (loading) {
    <div
      class="z-10 flex items-center justify-center absolute inset-0 bg-white/75"
      >
      <div class="flex items-center justify-center">
        <div
          class="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]"
          role="status">
          <span
            class="!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]"
            >Loading...</span
            >
          </div>
        </div>
      </div>
    }
  </div>
